import { render } from "./router.vue?vue&type=template&id=9cca362a&scoped=true"
import script from "./router.vue?vue&type=script&lang=js"
export * from "./router.vue?vue&type=script&lang=js"

import "./router.vue?vue&type=style&index=0&id=9cca362a&scoped=true&lang=css"

import exportComponent from "/Users/projects/crud/liderombor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cca362a"]])

export default __exports__